<template>
	<div class="text-orange text-nowrap display-1 font-weight-ultra-light" :class="classNummber">
		<vue-count-up 	:endVal="endVal"
						:delay="delay"
						:decimals="decimals"
						:options="options"
						@ready="onReady"
						v-if="show">
		</vue-count-up>
		<sup class="d-inline-block text-sup pl-3" v-if="textSup"> {{textSup}} </sup>
	</div>
</template>
<script>
	import VueCountUp from 'vue-countup-v2'
	export default {
		components: {
			VueCountUp
		},
		props: {
			show: {
				type: Boolean,
				default: false
			},
			endVal: {
				type: Number,
				default: 9999
			},
			delay: {
				type: Number,
				default: 0
			},
			variant: {
				type: String,
				default: 'warning'
			},
			prefix: {
				type: String,
				default: ''
			},
			suffix: {
				type: String,
				default: ''
			},
			textSup: {
				type: String,
				default: ''
			},
			classNummber: {
				type: String,
				default: ''
			},
			decimals: {
				default: () => 0
			},
		},
		data() {
			return {
				options: {
					useEasing: 		true,
					useGrouping: 	true,
					separator: 		this.$creo.getLang() == 'sv' ?' ' : ',',
					decimal: 		this.$creo.getLang() == 'sv' ?',' : '.',
					prefix: 		this.prefix,
					suffix: 		this.suffix,
					decimalPlaces: this.decimals,
				}
			}
		},
		methods: {
			onReady(instance, CountUp) {
				this.$emit('countUpDone', true)
			}
		}
	}
</script>
